export class ConversionUtils {
  public static getFpsFromMs(milliseconds: number, framerate: number) {
    const result = Math.floor(((milliseconds ?? 0) * (framerate ?? 0)) / 1000);
    //console.log('ConversionUtils->getFpsFromMs-> ', milliseconds, framerate, result);

    return result;
  }

  public static getMsFromFps(fps: number, framerate: number) {
    return Math.floor(((fps ?? 0) * 1000) / framerate);
  }

  public static convertToUTC(date: Date) {
    const now_utc = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
    );

    return now_utc;
  }

  public static convertMiliseconds(miliseconds: number, format: string = "no") {
    let days,
      hours,
      minutes,
      seconds,
      total_hours: number,
      total_minutes,
      total_seconds,
      ms;

    ms = miliseconds % 1000;
    total_seconds = Math.floor(miliseconds / 1000);
    total_minutes = Math.floor(total_seconds / 60);
    total_hours = Math.floor(total_minutes / 60);
    days = Math.floor(total_hours / 24);

    seconds = Math.floor(total_seconds % 60);
    minutes = Math.floor(total_minutes % 60);
    hours = Math.floor(total_hours % 24);

    switch (format) {
      case "s":
        return total_seconds;
      case "m":
        return total_minutes;
      case "h":
        return total_hours;
      case "d":
        return days;
      default:
        return { d: days, h: hours, m: minutes, s: seconds, ms: ms };
    }
  }
}
